import { createMandatoryContext } from 'contexts/utils';
import { PartnerContent } from 'types/Partner';
import { StateSetter } from 'types/utils/React';
import { PartnerAccount } from 'types';

interface PartnerContentContextProps {
  contents: PartnerContent[];
  partnerAccount: PartnerAccount;
  selectedContent: PartnerContent;
  setSelectedContent: StateSetter<PartnerContent | undefined>;
}

const partnerContentContext =
    createMandatoryContext<PartnerContentContextProps>(),
  [usePartnerContentContext, PartnerContentContextProvider] =
    partnerContentContext;

export { usePartnerContentContext, PartnerContentContextProvider };
